/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrService } from './irrService';
import { SaasEnvironment } from './saasEnvironment';


/**
 * IRR Get Config Response.
 */
export interface GetIrrConfigResponse { 
    env?: SaasEnvironment;
    services?: Array<IrrService>;
}

